import { render, staticRenderFns } from "./a-propos-aleo.vue?vue&type=template&id=f6fc671c&scoped=true&"
import script from "./a-propos-aleo.vue?vue&type=script&lang=js&"
export * from "./a-propos-aleo.vue?vue&type=script&lang=js&"
import style0 from "./a-propos-aleo.vue?vue&type=style&index=0&id=f6fc671c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fc671c",
  null
  
)

/* custom blocks */
import block0 from "./a-propos-aleo.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,Scroll: require('/app/components/Scroll.vue').default,ListCheckRed: require('/app/components/ListCheckRed.vue').default,TalkWithExpert: require('/app/components/TalkWithExpert.vue').default,FooterV2: require('/app/components/FooterV2.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default})
